import { render } from "./attachmentTable.vue?vue&type=template&id=38cd5074&scoped=true"
import script from "./attachmentTable.vue?vue&type=script&lang=js"
export * from "./attachmentTable.vue?vue&type=script&lang=js"

import "./attachmentTable.vue?vue&type=style&index=0&id=38cd5074&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd5074"]])

export default __exports__